import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "rotateFilled"
const RotateFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M14.266 20.128C13.535 20.332 12.772 20.438 12 20.438 11.227 20.438 10.465 20.332 9.734 20.128L10.238 18.322C10.806 18.48 11.398 18.562 12 18.562 12.6 18.563 13.193 18.48 13.762 18.323zM14.826 4.5 11.538 7.788 10.212 6.462 11.185 5.49C10.465 5.579 9.762 5.788 9.104 6.11 7.85 6.728 6.826 7.727 6.18 8.966 5.535 10.204 5.3 11.616 5.513 12.996S6.372 15.653 7.36 16.641C7.784 17.066 8.262 17.426 8.776 17.716L7.855 19.349C7.194 18.976 6.58 18.513 6.033 17.966 4.764 16.696 3.933 15.055 3.66 13.28S3.688 9.69 4.518 8.098C5.348 6.507 6.665 5.221 8.276 4.43 9.22 3.965 10.236 3.685 11.27 3.595L10.212 2.538 11.538 1.212zM19.349 16.145C18.976 16.806 18.512 17.42 17.966 17.966 17.42 18.513 16.806 18.976 16.145 19.35L15.224 17.716C15.738 17.426 16.216 17.066 16.64 16.64 17.065 16.216 17.426 15.738 17.716 15.224zM20.128 9.734C20.33 10.465 20.438 11.227 20.438 12S20.33 13.535 20.127 14.266L18.32 13.762C18.48 13.193 18.562 12.601 18.562 12S18.48 10.807 18.322 10.238zM17.966 6.034C18.512 6.58 18.976 7.194 19.35 7.855L17.716 8.775C17.426 8.263 17.066 7.786 16.64 7.36z" />
        </svg>
      }
    </span>
  )
}
export default RotateFilledIcon
